/**
=========================================================
* Material Dashboard 2 PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import React from "react";

import { useState, useEffect } from "react";

// react-router components
import { useLocation, Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @material-ui core components
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import Icon from "@mui/material/Icon";
import Search from "@mui/icons-material/Search";

// Material Dashboard 2 PRO React components
import MDBox from "../../MDBox";
import MDInput from "../../MDInput";
import MDBadge from "../../MDBadge";

// Material Dashboard 2 PRO React example components
import Breadcrumbs from "../../Breadcrumbs";
import NotificationItem from "../../Items/NotificationItem";
import Button from '../../Button.jsx';

import { TipoMensajeWeb, EstadoNotificacionWeb, Roles } from "../../../othelloConstantes.jsx";
//import DialogNotificaciones from "../../../view/Dialogs/DialogNotificaciones.js";


// Custom styles for DashboardNavbar
import {
  navbar,
  navbarContainer,
  navbarRow,
  navbarIconButton,
  navbarDesktopMenu,
  navbarMobileMenu,
} from "./styles";

// Material Dashboard 2 PRO React context
import {
  useMaterialUIController,
  setTransparentNavbar,
  setMiniSidenav,
  setOpenConfigurator,
} from "../../../context";



function DashboardNavbar({ absolute, light, isMini, rutasactual, oficina, idRol, loginmodoreserva, loginapps  }) {
    const [navbarType, setNavbarType] = useState();
    const [controller, dispatch] = useMaterialUIController();
    const { miniSidenav, transparentNavbar, fixedNavbar, openConfigurator, darkMode } = controller;
    const [openMenu, setOpenMenu] = useState(false);
    const route = useLocation().pathname.split("/").slice(1);

    const [notificaciones, setNotificaciones] = useState(null);
    const [id_msj_web, setIdMsjWeb] = useState(null);

    useEffect(() => {
        // Setting the navbar type
        if (fixedNavbar) {
            setNavbarType("sticky");
        } else {
            setNavbarType("static");
        }

        // A function that sets the transparent state of the navbar.
        function handleTransparentNavbar() {
            setTransparentNavbar(dispatch, (fixedNavbar && window.scrollY === 0) || !fixedNavbar);
        }

        /** 
         The event listener that's calling the handleTransparentNavbar function when 
         scrolling the window.
        */
        window.addEventListener("scroll", handleTransparentNavbar);

        // Call the handleTransparentNavbar function to set the state with the initial value.
        handleTransparentNavbar();

        // Remove event listener on cleanup
        return () => window.removeEventListener("scroll", handleTransparentNavbar);
    }, [dispatch, fixedNavbar]);

    const handleMiniSidenav = () => setMiniSidenav(dispatch, !miniSidenav);
    const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

    const getNotificacionesResumido = () => {

       /* var jsonData = JSON.stringify({ tipo: [TipoMensajeWeb.Excepcion, TipoMensajeWeb.Aviso], modulo: "" });

        fetch('api/NotificacionesData/GetNotificacionesResumido', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: jsonData

        }).then(response => response.json()).then(res => {
            setNotificaciones(res);
        }).catch(error => {

        });*/
    }

    const handleOpenMenu = (event) => {
        setOpenMenu(event.currentTarget);
        getNotificacionesResumido();
    }

    const handleCloseMenu = () => setOpenMenu(false);

    const handleCloseDialogNotificaciones = (result) => {
        setIdMsjWeb(0);
        getNotificacionesResumido();
    }

    const handleClickNotificacion = (result) => {
        if (result != null && result > 0) {
            setIdMsjWeb(result);
        }
    }

    // Render the notifications menu
    const renderMenu = () => {

        let final = "";

        final = <Menu
            anchorEl={openMenu}
            anchorReference={null}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            open={Boolean(openMenu)}
            onClose={handleCloseMenu}
            sx={{ mt: 2 }}
        >{
                notificaciones != null && notificaciones.length > 0 ? notificaciones.map(x => <NotificationItem icon={(x.estado != EstadoNotificacionWeb.Leido ? <Icon>addalert</Icon> : "")} title={x.titulo} onClick={() => handleClickNotificacion(x.id_msj_web)} />) :
                    //< MenuItem onClick={() => click(x.id_msj_web)} className={dropdownItem}>{x.estado != EstadoNotificacionWeb.Leido ? <AddAlert /> : ""}{x.titulo}</MenuItem>);
                    <NotificationItem icon={<Icon>email</Icon>} title="Sin Notificaciones" />
            }
        </Menu>

        return final;
    }

    // Styles for the navbar icons
    const iconsStyle = ({ palette: { dark, white, text }, functions: { rgba } }) => ({
        color: () => {
            let colorValue = light || darkMode ? white.main : dark.main;

            if (transparentNavbar && !light) {
                colorValue = darkMode ? rgba(text.main, 0.6) : text.main;
            }

            return colorValue;
        },
    });

    let dialogmensaje = "";

    if (id_msj_web != null && id_msj_web > 0)
        dialogmensaje = "";// <DialogNotificaciones literal={null} id_msj_web={id_msj_web} onCloseModalResulDialogNotificaciones={handleCloseDialogNotificaciones} />

    let numnoti = 0;

    if (notificaciones != null && notificaciones.length > 0)
        numnoti = notificaciones.filter(x => x.estado != EstadoNotificacionWeb.Leido).length;


    const getTituloRuta = (rutas) => {

        let routename = route[route.length - 1];
        let namefinal = "";

        rutas.forEach(x => {
            if (x.collapse != null && x.collapse.length > 0)
            {
                let res = getTituloRuta(x.collapse);

                if (res != null && res != "")
                    namefinal = res;
            }
            //sino, compruebo lo actual
            else {

                let valores = x.key.toLowerCase().split('/');

                if (valores != null && valores.length > 1) {

                    let namecompare = valores[route.length - 1];

                    if (namecompare == routename)
                        namefinal = x.name;
                }
            }
        });

        return namefinal;
    };


    const getTitleRutaShowed = () => {

        if (rutasactual != null && rutasactual.length > 0)
        {
            let valor = getTituloRuta(rutasactual);

            if (valor != null && valor != "")
                return valor;
        }        

        return route[route.length - 1];
    }

    const getTitleOficina = () => {
        //(oficina.length >= 23 ? oficina.substring(0, 23) + "..." : oficina);
        var CurrentOfi = "OFICINA: " + oficina;

        if (window.innerWidth < 400)
            CurrentOfi = oficina.length > 7 ? oficina.substring(0, 7) + "" : oficina;
        else if (window.innerWidth < 500)
            CurrentOfi = oficina.length > 7 ? oficina.substring(0, 7) + "..." : oficina;
        else if (window.innerWidth < 650)
            CurrentOfi = oficina.length > 24 ? oficina.substring(0, 21) + "..." : oficina;

        return CurrentOfi;
    }

    let ruteexit = "/auth/login";

   
   if (loginmodoreserva)
       ruteexit = "/authapps/loginreservas";
   else if (loginapps)
       ruteexit = "/authapps/loginapp";

    return (
        <AppBar
            position={absolute ? "absolute" : navbarType}
            color="inherit"
            sx={(theme) => navbar(theme, { transparentNavbar, absolute, light, darkMode })}
        >
            <Toolbar sx={(theme) => navbarContainer(theme)}>
                <MDBox color="inherit" mb={{ xs: 1, md: 0 }} sx={(theme) => navbarRow(theme, { isMini })}>                                      
                    <IconButton sx={navbarDesktopMenu} onClick={handleMiniSidenav} size="small" disableRipple>
                        <Icon fontSize="medium" sx={iconsStyle}>
                            {miniSidenav ? "menu_open" : "menu"}
                        </Icon>
                    </IconButton>
                    <Breadcrumbs icon="home" title={getTitleRutaShowed()} route={route} light={light} />
                    {/*{idRol != Roles.UsuarioApp && !loginmodoreserva && !loginapps ? <Button color="instagram" size="small" variant="gradient" key={prop.id} onClick={() => onKeyDownBoton(prop.id, prop.permiso)}><prop.icon />&nbsp;{prop.texto}</Button> : ""}*/}
                    {/*{idRol != Roles.UsuarioApp && !loginmodoreserva && !loginapps ? <Button color="instagram" size="small" variant="gradient" key={prop.id} onClick={() => onKeyDownBoton(prop.id, prop.permiso)}><prop.icon />&nbsp;{prop.texto}</Button> : ""}*/}                    
                    {idRol != Roles.UsuarioApp && !loginmodoreserva && !loginapps ? <Button color="facebook" component={Link} to="/admin/oficina">{getTitleOficina()}</Button> : ""}
                    {idRol != Roles.UsuarioApp && !loginmodoreserva && !loginapps ? <Button color="tumblr" component={Link} to="/admin/oficinas"><Search /> {window.innerWidth > 760 ? "MIS OFICINAS" : "OFI."} </Button> : ""}
                </MDBox>
                {isMini ? null : (
                    <MDBox sx={(theme) => navbarRow(theme, { isMini })}>
                        {/*<MDBox pr={1}>*/}
                        {/*  <MDInput label="Search here" />*/}
                        {/*</MDBox>*/}
                        <MDBox color={light ? "white" : "inherit"}>
                            <Link to={ruteexit}>
                                <IconButton sx={navbarIconButton} size="small" disableRipple>
                                    <Icon sx={iconsStyle}>logout</Icon>
                                </IconButton>
                            </Link>
                            <IconButton
                                size="small"
                                disableRipple
                                color="inherit"
                                sx={navbarMobileMenu}
                                onClick={handleMiniSidenav}
                            >
                                <Icon sx={iconsStyle} fontSize="medium">
                                    {miniSidenav ? "menu_open" : "menu"}
                                </Icon>
                            </IconButton>
                            {/*<IconButton*/}
                            {/*  size="small"*/}
                            {/*  disableRipple*/}
                            {/*  color="inherit"*/}
                            {/*  sx={navbarIconButton}*/}
                            {/*  onClick={handleConfiguratorOpen}*/}
                            {/*>*/}
                            {/*  <Icon sx={iconsStyle}>settings</Icon>*/}
                            {/*</IconButton>*/}
                            <IconButton
                                size="small"
                                disableRipple
                                color="inherit"
                                sx={navbarIconButton}
                                aria-controls="notification-menu"
                                aria-haspopup="true"
                                variant="contained"
                                onClick={handleOpenMenu}>
                                {numnoti > 0 ?
                                    <MDBadge badgeContent={numnoti} color="error" size="xs" circular>
                                        <Icon sx={iconsStyle}>notifications</Icon>
                                    </MDBadge> : <Icon sx={iconsStyle}>notifications</Icon>}
                            </IconButton>
                            {renderMenu()}
                            {dialogmensaje}
                        </MDBox>
                    </MDBox>
                )}
            </Toolbar>
        </AppBar>
    );
}

// Setting default values for the props of DashboardNavbar
DashboardNavbar.defaultProps = {
  absolute: false,
  light: false,
  isMini: false,
};

// Typechecking props for the DashboardNavbar
DashboardNavbar.propTypes = {
  absolute: PropTypes.bool,
  light: PropTypes.bool,
  isMini: PropTypes.bool,
};

export default DashboardNavbar;
